module.exports = __webpack_public_path__ + "static/media/bajopiso.0ed27f9f.jpg";